import { Navigate, useParams } from "react-router-dom";

// Modules are now part of the unified course split view.
// Redirect any deep-link to the parent course page.
export default function CourseModule() {
  const { id } = useParams();
  return <Navigate to={`/course/${id}`} replace />;
}
